<template>
  <div class="advisoryManLits">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="addForm"
        label-position="rigth"
        label-width="100px"
        :rules="addFormRule"
        ref="addForm"
      >
        <div class="form-item-wrap">
          <el-form-item label="消息标题" prop="title">
            <el-input v-model="addForm.title" style="width: 200px"></el-input>
          </el-form-item>
        </div>
        <!-- <div class="form-item-wrap">
          <el-form-item label="副标题" prop="subTitle">
            <el-input v-model="addForm.subTitle" style="width:200px;"></el-input>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="消息分类" prop="type">
            <el-select
              v-model="addForm.type"
              placeholder="请选择"
              style="width: 200px"
            >
              <el-option label="首页视频" value="445"></el-option>
              <el-option label="首页图文" value="446"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序" prop="sortId">
            <el-input-number v-model="addForm.sortId" :min="1" style="width:200px;"></el-input-number>
          </el-form-item>
        </div>
        <!-- <div class="form-item-wrap">
          <el-form-item label="排序值" prop="sort">
            <el-input-number v-model="addForm.sort" :min="1" style="width:200px;"></el-input-number>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="发布日期" prop="sendTime">
            <el-date-picker
              v-model="addForm.sendTime"
              type="datetime"
              style="width: 200px"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="发布日期"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="文章摘要" prop="abstract">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              style="width: 800px"
              rows="5"
              v-model="addForm.abstract"
            >
            </el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="封面图片" prop="">
            <!-- 图片预览组件 -->
            <img-view
              :imgList="[{ url: classImg, id: 0, type:''}]"
              :isDelete="true"
              @handleDel="delGoodsImg(item)"
            >
            </img-view>
            <!-- 文件上传组件 -->
            <upload @fileChange="imgFallback" accept="#"> </upload>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="文章内容" prop="content">
            <!-- <wang-editor :value="addForm.content" @change="change" style="width:800px"></wang-editor> -->
            <tinymce
              :value="addForm.content"
              @input="change"
              :isEditorLoad="isEditorLoad"
            ></tinymce>
          </el-form-item>
        </div>
        <div class="form-item-wrap" style="margin-top: 20px">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button type="info" @click="resetForm">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
//组件
// import WangEditor from "@/components/WangEditor.vue";
import Tinymce from "@/components/Tinymce";
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "advisoryManLits",
  data() {
    return {
      id: "",
      //新增表单
      addForm: {
        title: "", // 文章标题
        subTitle: "", // 副标题
        type: "445", // 类型
        sendTime: "", // 发布日期
        abstract: "", // 摘要
        content: "", // 内容
        imgUrl: "",
        sortId: "", // 排序
      },
      addFormRule: {
        title: [mustFill],
        type: [mustFill],
        sendTime: [mustFill],
      },
      isEditorLoad: false, // 编辑器是否加载完成
      classImg: "",
      mp4: "",
      map4: "",
    };
  },
  components: {
    Tinymce,
  },
  mounted() {
    //接收role传递参数
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      this.id = prams.id;
      this.addForm.sortId = prams.sortId || 1;
      this.getData();
    }else {
      this.addForm.sortId = 1;
    }
    this.addForm.sendTime = this.$theMonthFirstOnDayday();
  },
  methods: {
    /**富文本编辑内容改变回调 */
    change(val) {
      this.addForm.content = val;
    },
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    // 获取基础数据
    getData() {
      let data = {
        type: "QueryArticleMt",
        id: this.id,
      };
      let proc = ""; //存储过程名
      let type = "QueryArticleMt";
      this.$requestSys({
        method: "post",
        url:
          "article/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            let data = res.data[0];
            console.log('data',data);
            this.map4 = data.img_url.substr(-3);
            this.addForm.title = data.title;
            this.addForm.subTitle = data.tags;
            this.addForm.type = data.category_id;
            // this.addForm.sort = data.sort_id;
            this.addForm.sendTime = data.add_time;
            this.addForm.abstract = data.zhaiyao;
            this.addForm.imgUrl = data.img_url;
            this.classImg = this.$setImgUrl(data.img_url);
            this.addForm.content = decodeURIComponent(atob(data.content));
            this.isEditorLoad = true;
             // 如果是从父页面传过来的sortId，保持原值；否则使用接口返回的sort_id
             if (this.addForm.sortId === "") {
              this.addForm.sortId = data.sort_id;
            }
            console.log(this.classImg, "111111111111", this.map4);
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**图片成功上传回调 */
    imgFallback(file) {
      if (file.length) {
        //将上传的图片file对象直接转化为blob地址，无需重新获取商品详情
        this.classImg = URL.createObjectURL(file[0]);
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("UploadVideo", file[i]);
        }
        let type = "categorys";
        this.$uploadRequest({
          url: "admin/ashx/UploadImg.ashx?type=UploadImage&imgType=" + type,
          method: "post",
          data: fileData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.addForm.imgUrl = res.message;
              this.mp4 = res.message.substr(-3);
              this.$message({
                message: "图片上传成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            entid: localStorage.getItem("entId"),
            title: this.addForm.title,
            channelId: "20",
            categoryId: this.addForm.type,
            imgUrl: this.addForm.imgUrl,
            sortId: this.addForm.sortId,
            dates: this.addForm.sendTime,
            zhaiYao: this.addForm.abstract,
            content: btoa(encodeURIComponent(this.addForm.content)),
            id: this.id,
          };
          this.$request({
            method: "post",
            url: "Article/SavePopularScience",
            data: data,
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.replace({
                  path: "/advisory/homeSystem",
                  query: {
                    updatedId: this.id,
                    updatedSortId: this.addForm.sortId,
                    refresh: 'true' // 标记需要刷新
                  }
                })
                this.goBack();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    /**重置表单 */
    resetForm() {
      this.$refs["addForm"].resetFields();
    },
    delGoodsImg(item) {
      console.log(item, "1111111");
    },
  },
};
</script>

<style scoped>
.advisoryManLits {
  width: 100%;
  height: 100%;
}
</style>
